import { getSurveyOptions } from "@pulse/api/queryApi";
import { PreviewSurveyContent } from "@pulse/features/Edit/PreviewSurvey/PreviewSurveyContent";
import { SurveyEdit } from "@pulse/features/Edit/SurveyEdit";
import { queryClient } from "@pulse/queryClient";
import { createFileRoute, notFound, rootRouteId } from "@tanstack/react-router";
import { z } from "zod";

const editSearchSchema = z.object({
    preview: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit")({
    component: RouteComponent,
    validateSearch: editSearchSchema,
    staticData: {
        titleFn: (t) => t("title.createSurvey"),
    },
    loader: async ({ params }) => {
        await queryClient
            .ensureQueryData(getSurveyOptions({ surveyId: +params.surveyId }))
            .then((survey) => {
                if (survey.pulseInstanceId !== +params.pulseId || survey.status !== "DRAFT") {
                    throw new Error("Survey is not in DRAFT");
                }
            })
            .catch(() => {
                throw notFound({ routeId: rootRouteId });
            });
    },
});

function RouteComponent() {
    const { preview } = Route.useSearch();

    return preview ? <PreviewSurveyContent /> : <SurveyEdit />;
}
